import { AdapterUi } from '@core/store/adapters/global.adapter';
import { createAction, props } from '@ngrx/store';

export enum GlobalAction {
    ClearAll = '[GLOBAL] Clear all global',
    UiGlobal = '[GLOBAL] UI Global',
    Empty = '[GLOBAL] Empty'
}

export const clearAll = createAction(GlobalAction.ClearAll);
export const uiGlobal = createAction(GlobalAction.UiGlobal, props<{ui: Array<AdapterUi>}>());
export const Empty = createAction(GlobalAction.Empty);

